import PropType from 'prop-types';
import {RecipeTeaser, RecipeTitle, Image} from './styles';
import TextTruncate from 'react-text-truncate';
import {colors, fonts} from 'ui/config';

const Recipe = ({recipe}) => (
  <RecipeTeaser to={`/recipe/${recipe.id}`}>
    <Image src={recipe.acf.recette_image_principale.url} />
    <RecipeTitle>
      <TextTruncate
        style={{
          fontFamily: fonts.title,
          fontWeight: 'bold',
          textAlign: 'center',
          fontSize: 16,
          lineHeight: '19px',
          color: colors.black,
        }}
        text={recipe.title.rendered.replace(/&#8217;/g, "'").replace(/&rsquo;/g, "'")}
        line={3}
      />
    </RecipeTitle>
  </RecipeTeaser>
);

Recipe.propTypes = {
  recipe: PropType.object.isRequired,
};

export default Recipe;
